/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
/**
 * 微存储屏蔽板载口的控制器model枚举值列表
 */
export const MICRO_WITHOUT_ONBOARD_PORT_CTRL_MODEL_LIST = ['4155'];

/**
 * 微存储屏蔽板载口的控制框model枚举值列表
 */
export const MICRO_WITHOUT_ONBOARD_PORT_CTRL_ENCLOSURE_LIST = ['mid_115'];

/**
 * 温度非法返回值
 */
export const TEMPERATURE_INVALID_VALUE = -1;

/**
 * 转接卡类型名称 术语变更 riser-->carrier-->box
 */
export enum CarrierTypeE {
    /** 默认转接卡名称 */
    CARRIER = 'carrier',
    /** 8槽位接口板盒 */
    CARRIER_FOR_CARD = 'carrierForCard',
    /** 32槽位盘盒 */
    CARRIER_FOR_DISK = 'carrierForDisk',
}

/**
 * 机框名称枚举
 */
export enum EnclosureTypeE {
    /** 北辰8UA800机框 */
    BC_8U_A800 = 'bc_8u_a800',
    /** 司南1.5 2u双控4卡 */
    SI_NAN_2U_2C_4CARD = 'si_nan_2u_2c_4card_139',
    /** 司南1.5 2u双控6卡 */
    SI_NAN_2U_2C_6CARD = 'si_nan_2u_2c_6card_140',
}

/**
 * 转接板型号枚举 术语变更 riser-->carrier-->box
 */
export enum CarrierModelE {
    /** 8接口卡 carrier */
    EIGHT_CARDS = '32768',
    /** 32盘 carrier */
    THIRTY_TWO_DISKS = '32769',
}

/**
 * 转接板MODEL值和转接板类型名称印射表 术语变更 riser-->carrier-->box
 */
export const CARRIER_FRU_TYPE_MAP = {
    [CarrierModelE.EIGHT_CARDS]: CarrierTypeE.CARRIER_FOR_CARD,
    [CarrierModelE.THIRTY_TWO_DISKS]: CarrierTypeE.CARRIER_FOR_DISK,
};

/**
 * 适配CTEX的结尾
 */
export const CTE_SMM_END_STR = 'SMM';